module.exports = __webpack_public_path__ + "templates/user.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/auth/management/user/user.html
// module id = 361
// module chunks = 15